import { render, staticRenderFns } from "./HeadlineTranslationsForm.vue?vue&type=template&id=f8541a48&scoped=true&"
import script from "./HeadlineTranslationsForm.vue?vue&type=script&lang=js&"
export * from "./HeadlineTranslationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8541a48",
  null
  
)

export default component.exports